// extracted by mini-css-extract-plugin
export default {"list":"NAojPlm5tVcwCL7VwBO8","tab":"lsq8E02lBnuN2SUgfkAC","tabActive":"dh2HnIGUSg3Wj36yr3X3"};